import { BaseCategory, SlideBuilder } from "./BaseCategory";
import { ElementTextBlockPositionType, HorizontalAlignType, PaletteColorType, PositionType, TextStyleType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class TextCategory extends BaseCategory {
    get name() {
        return "Text";
    }

    get type() {
        return SlideCategories.TEXT;
    }

    get icon() {
        return null;
    }

    get description() {
        return "The content contain one or more sentences of text that is not a list or factoid. Use for free-form text or key concepts, definitions, or unstructured content that is not a list or diagram.  You can use this category if the content is primarily textual information but includes one or more images.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Provide the text for the slide.`;
    }

    getImagePrompt() {
        return "Optionally and if appropriate, you can also suggest a prompt for generating an image to use on the slide. The image should be a single subject or abstract concept related to the topic of the slide.";
    }

    getPromptSchema() {
        return {
            label: "an optional short label or title for the text content",
            text: "richtext for the slide",
            conclusion: "an optional short conclusion or takeaway for the slide. plain text only, no rich text",
        };
    }

    getSlideModels(model) {
        let models = [
            this.buildText(model, true, PositionType.RIGHT),
            this.buildText(model, true, PositionType.LEFT),
            // this.buildText(model, true, PositionType.BACKGROUND),
            this.buildText(model, false, null),

        ];

        return models;
    }
                  w
                  buildText(model, showImage, headlinePosition) {
                      let builder = new SlideModelBuilder("headline2", model);

                      let primary = {
                          fullBleed: true,
                          showGutter: true,
                          dividerSize: 0.6666,
                          headlinePosition,
                          textPosition: PositionType.LEFT,
                          textAlign: HorizontalAlignType.LEFT,
                          text: {
                              blocks: [
                                  builder.createBlock(model.label, TextStyleType.LABEL, { fontColor: PaletteColorType.THEME }),
                                  builder.createBlock(model.slideTitle, TextStyleType.HEADING),
                                  ...builder.cleanUpRichText(model.text)
                              ]
                          },
                      };

                      for (let i = 1; i < primary.text.blocks.length; i++) {
                          let block = primary.text.blocks[i];
                          block.spaceAbove = 10;
                      }

                      if (model.slideImage?.prompt && headlinePosition) {
                          // primary.backdropStyle = "white_box";
                          primary.items = [{
                              componentType: "TextAndImage",
                              childElement: builder.createImage(model.slideImage?.prompt, {}, true)
                          }];
                      }

                      if (headlinePosition) {
                          primary.headlinePosition = headlinePosition;
                      }

                      builder.createPrimary(primary);

                      if (model.conclusion) {
                          builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.TRAY);
                      }

                      return builder.model;
                  }
}

